module.exports = __webpack_public_path__ + "img/idea-collection-background.4a307997.png";